<template>
	<div i='right_function' v-show="showclose">
		<div class="right-top">
            <div class="right_close" @click="showclose = false">关闭</div>
			<div class="Return-top ">
			<div class="bolang-img bg-cover"></div>
			</div>
			<div class="down-app">
				<a :href="donw_url.url" target="view_window">
					<div class="down-qrod">
						<img :src="donw_url.qr_code"/>
					</div>
					<div class="down-text">
						下载app
					</div>
				</a>
			</div>
			<div class="customer-chat" @mouseover="hover=true;" @mouseout='hover=false' @click="MEIQIA()">
				<div class="chat-img">
					<img v-if="hover"  src="/static/images/chatb.png" alt="" />
					<img v-else src="/static/images/chat.png" alt="" />
				</div>
				<div class="chat-text" :class="{'active':hover}" @click="show">
					在线客服
				</div>
			</div>
		</div>
		<div class="go-top" @click="scroo">
			<img src="/static/images/top.png"/>
		</div>
	</div>
</template>

<script >
	 export default{
        data(){
            return{
				hover:false,
                donw_url:{},
                showclose: true
            }
        },
        methods:{
			 /*返回顶部*/
            show(){

			},
            doWnload(){
                let that = this,
                    ajaxData={};
                tools.alert.loading();
                tools.ajax({
                    url: '/api/download/app',
                    ajaxData:ajaxData,
                    successFun: function (res) {
                        that.donw_url = res.data;
                        tools.alert.closeLoading();
                    },
                    errorFun: function (error_data, status, headers, error_obj) {
                        tools.alert.closeLoading();
                        tools.alert.error(error_data.error_msg);
                    },
                    type: 'GET'
                });
            },
        	scroo(){
				let that = this;
				$("html,body").animate({scrollTop:0},300);
        	},
            MEIQIA(){
                let that = this;
                if (!JSON.parse(tools.cache.get('status'))) {
                    that.$store.state.app.dialogVisible = true;
                    that.$store.state.app.sin_login = true;
                    return
                }
                _MEIQIA('showPanel');
			}
        },
        watch: {

        },
        components:{

        },
        filters: {

        },
        mounted(){
			this.doWnload();
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
@import '../assets/sass/right.scss';
.right_close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    z-index: 9999;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// Right.vue?69f51100